import React, { useEffect, useRef, useState } from 'react';
import OpalHostSection from './OpalHostSection/OpalHostSection';
import './OpalHostContainer.css';
import setting from '../../../config.json';

const OpalHostContainer = ({ itemSection, chartPalette, chartTheme, autoScale, isModal }) => {
  const [isXL, setIsXL] = useState(window.innerWidth <= 1200);
  const [isLG, setIsLG] = useState(window.innerWidth <= 992);
  const [isMD, setIsMD] = useState(window.innerWidth <= 768);

  const containerRef = useRef();
  const [height, setHeight] = useState(null);

  const calculateTotalRows = async (sections) => {
    const maxCols = 12;
    const grid = []; // 2D grid, each row is an array of 12 cells

    const findPlacement = (colSpan, rowSpan) => {
      for (let row = 0; row <= grid.length; row++) {
        for (let col = 0; col <= maxCols - colSpan; col++) {
          let fits = true;

          // Check if block fits in colSpan x rowSpan from (row, col)
          for (let r = 0; r < rowSpan; r++) {
            const gridRow = grid[row + r] || [];
            for (let c = col; c < col + colSpan; c++) {
              if (gridRow[c]) {
                fits = false;
                break;
              }
            }
            if (!fits) break;
          }

          if (fits) {
            // Mark the space as used
            for (let r = 0; r < rowSpan; r++) {
              const targetRow = grid[row + r] || [];
              for (let c = col; c < col + colSpan; c++) {
                targetRow[c] = true;
              }
              grid[row + r] = targetRow;
            }
            return;
          }
        }
      }

      // If no fit found, extend grid
      const startRow = grid.length;
      for (let r = 0; r < rowSpan; r++) {
        const newRow = [];
        for (let c = 0; c < colSpan; c++) {
          newRow[c] = true;
        }
        grid[startRow + r] = newRow;
      }
    };

    // Process all sections
    for (const section of sections) {
      const colSpan = section.columns || 12;
      const rowSpan = section.rows || 1;
      findPlacement(colSpan, rowSpan);
    }

    return grid.length;
  };



  const updateContainerHeight = async () => {
    const totalRows = await calculateTotalRows(itemSection);

    if (containerRef.current) {
      const heightPx = containerRef.current.offsetHeight;

      // Padding: 16px total (from p-2)
      const paddingPx = 16;

      // Gap between rows: (totalRows - 1) * 0.5rem in px
      // 0.5rem = 8px (assuming 16px root font size)
      const gapPx = (totalRows - 1) * 8;

      // Effective height = total height minus padding minus gap space
      const effectiveHeightPx = heightPx - paddingPx - gapPx;

      const heightRem = effectiveHeightPx / 16; // Convert px to rem

      const displayedRows = autoScale ? totalRows : 4;
      setHeight(heightRem / displayedRows);
    }
  };

  useEffect(() => {
    updateContainerHeight(); // On mount and itemSection update
    window.addEventListener('resize', updateContainerHeight); // Recalculate on resize

    return () => {
      window.removeEventListener('resize', updateContainerHeight);
    };
  }, [itemSection]);

  useEffect(() => {
    const handleResize = () => {
      setIsXL(window.innerWidth <= 1200);
      setIsLG(window.innerWidth <= 992);
      setIsMD(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className='opal-host-container p-2' ref={containerRef}>
      {itemSection.map((section, index) => (
        <div
          key={index}
          style={{
            gridColumn: `span ${isMD ? 12 : section.columns}`,
            gridRow: `span ${section.rows}`,
          }}
        >
          <OpalHostSection section={section} palettes={chartPalette} themes={chartTheme} heightPerRow={isModal ? setting.hostSectionModalHeight : height} />
        </div>
      ))}
    </div>
  );
};

export default OpalHostContainer;
